module.exports = __webpack_public_path__ + "img/P150T_weapon_131.936cdb5d.png";